import { format as formatBase } from 'date-fns'
import { getLocale } from './getLocale'

export function format(firstDate: Date, formatStr: string) {
  return formatBase(firstDate, formatStr, {
    locale: getLocale(),
  })
}
